import type { FormatNumberOptions } from 'react-intl';
import { useIntl } from 'react-intl';
import { useConfig } from '../useConfig/useConfig';
import { formatPrice } from '../../utils/formatPrice/formatPrice';

export const useFormatPrice = () => {
  const { formatNumber, locale } = useIntl();
  const { priceFormat } = useConfig();

  return {
    /**
     * method to format a price value as float (in euros) to a customized price string
     *
     * @param price the price as float (in euros)
     * @param currency the currency for the price value
     * @returns string
     */
    formatPrice: (price: number, currency: FormatNumberOptions['currency']) =>
      formatPrice(price, currency, priceFormat, locale, formatNumber),
  };
};
